import { status, type StatusKind } from '~/lib/viz';

export function StatusBadge({ kind }: { kind: StatusKind }) {
  const s = status[kind];
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium"
      style={{ color: s.color, backgroundColor: `${s.color}1a` }}
    >
      <span aria-hidden>{s.icon}</span>
      {kind}
    </span>
  );
}
